import React from 'react';
import { BookmarkIcon, DownloadIcon } from 'lucide-react';
interface AlgaCoffeeSummaryWidgetProps {
  coffeeTitle: string;
  coffeeHost: string;
  coffeeTopics: string[];
}
const AlgaCoffeeSummaryWidget: React.FC<AlgaCoffeeSummaryWidgetProps> = ({
  coffeeTitle,
  coffeeHost,
  coffeeTopics
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-441">
      <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-442">
        <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-pink-500 mr-3" data-id="element-443">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-444" />
        </div>
        <div data-id="element-445">
          <h2 className="text-base font-semibold text-gray-800" data-id="element-446">
            Sintesi dell'evento
          </h2>
          <p className="text-xs text-gray-500" data-id="element-447">Powered by EIIS Intelligence</p>
        </div>
      </div>
      <div className="p-4" data-id="element-448">
        <div className="space-y-4" data-id="element-449">
          <div className="flex items-center justify-between" data-id="element-450">
            <h4 className="text-sm font-medium text-gray-800" data-id="element-451">
              Punti chiave discussi
            </h4>
            <div className="flex items-center space-x-2" data-id="element-452">
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-453">
                <BookmarkIcon size={16} className="text-gray-500" data-id="element-454" />
              </button>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-455">
                <DownloadIcon size={16} className="text-gray-500" data-id="element-456" />
              </button>
            </div>
          </div>
          <div className="text-sm text-gray-600" data-id="element-457">
            <ul className="list-disc pl-5 space-y-1" data-id="element-458">
              <li data-id="element-459">
                L'importanza di integrare strategie ESG nel core business
                aziendale
              </li>
              <li data-id="element-460">Come misurare l'impatto delle iniziative di sostenibilità</li>
              <li data-id="element-461">
                Sfide e opportunità nella transizione verso modelli di business
                più sostenibili
              </li>
              <li data-id="element-462">Best practices per il reporting di sostenibilità</li>
            </ul>
            <p className="mt-3" data-id="element-463">
              Durante l'evento, {coffeeHost} ha condiviso esperienze pratiche su
              come implementare strategie ESG efficaci, con particolare
              attenzione ai settori {coffeeTopics.join(', ')}.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaCoffeeSummaryWidget;